import * as styles from './Input.module.scss';

import cn from 'classnames';
import React from 'react';
import Icon, { IconPropView, isIconView } from 'src/components/ui/Icon';
import { WithHTMLAttributes } from 'src/types';

export const InputView = ['primary', 'additional'] as const;
export type InputPropView = typeof InputView[number];

export type InputProps = WithHTMLAttributes<
  {
    disabled?: boolean;
    readOnly?: boolean;
    value: string;
    type?: 'text' | 'password';
    view?: InputPropView;
    iconBefore?: IconPropView | React.ReactNode;
    iconAfter?: IconPropView | React.ReactNode;
    placeholder?: string;
    error?: string | boolean;
    onChange?: (value: string) => void;
    name?: string;
    small?: boolean;
  },
  HTMLInputElement
>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      view = 'primary',
      className,
      disabled,
      iconBefore,
      iconAfter,
      placeholder,
      value,
      onChange,
      type = 'text',
      error,
      small,
      ...props
    },
    ref
  ) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
      if (onChange) onChange(event.target.value);
    };

    return (
      <div className={cn(styles.input, className)}>
        {iconBefore &&
          (isIconView(iconBefore) ? <Icon className={cn(styles.input__icon, styles.input__icon_before)} view={iconBefore} /> : iconBefore)}
        <input
          ref={ref}
          type={type || 'text'}
          className={cn(
            styles.input__field,
            view && styles[`input__field_${view}`],
            error && styles.input__field_hasError,
            disabled && styles.input__field_disabled,
            iconBefore && styles.input__field_withIconBefore,
            iconAfter && styles.input__field_withIconAfter,
            small && styles.input__field_small
          )}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          {...props}
        />
        {iconAfter &&
          (isIconView(iconAfter) ? <Icon className={cn(styles.input__icon, styles.input__icon_after)} view={iconAfter} /> : iconAfter)}
      </div>
    );
  }
);

export default React.memo(Input);
